import { CategoryBrowser } from "@/features/catalog/CategoryBrowser";
import { useUI } from "@/stores/ui";

/** "Categories" from the phone tab bar, the header and the home rail: the full-screen category browser. */
export function CategorySheet() {
  const open = useUI((s) => s.categoriesOpen);
  const setOpen = useUI((s) => s.setCategoriesOpen);
  return <CategoryBrowser open={open} onClose={() => setOpen(false)} />;
}
